import { render, staticRenderFns } from "./subitem-info.vue?vue&type=template&id=0b87d389&scoped=true&"
import script from "./subitem-info.vue?vue&type=script&lang=js&"
export * from "./subitem-info.vue?vue&type=script&lang=js&"
import style0 from "./subitem-info.vue?vue&type=style&index=0&id=0b87d389&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b87d389",
  null
  
)

export default component.exports